
/*
 * @Author: zhangyugegeliuchen@didichuxing.com 
 * @Date: 2018-12-04 18:16:03
 * @Last Modified by: KongPei
 * @Last Modified time: 2020-03-31 15:17:59
 * @Description:  x推d  无活动页
 */
<template>
  <div>
    <header class="pad-header" v-if="isIPad">
      <p>{{gettext('推荐骑手')}}</p>
      <p @click="close">X</p>
    </header>
    <div :class="{'xtd-noactivity-container': !isIPad, 'iPad-xtd-noactivity-container': isIPad}">
      <div :class="{'xtd-noactivity-container-main': !isIPad, 'iPad-xtd-noactivity-container-main': isIPad}">
        <div :class="{'banner': !isIPad, 'iPad-banner': isIPad}">
          <img :class="{'img-wrapper': !isIPad, 'iPad-img-wrapper': isIPad}" v-lazy="lazyImgObj(formatHeadImg)"/>
        </div>
      </div>
      <div class="select-city" v-if="!isIPad" @click="jumpSelectCity">{{configInfo.cityName ? configInfo.cityName : gettext('选择城市')}}</div>
      <div class="xtd-noactivity-container-title" v-if="!isIPad">{{gettext("该城市暂无活动")}}</div>
      <div class="code-box">
        <div class="line-wrap" v-if="!isIPad">
          <span class="line l"></span>
          <span class="text">{{gettext('我的邀请码')}}</span>
          <span class="line r"></span>
        </div>
        <div class="copy-wrap">
          <span class="code">{{configInfo.activeCode}}</span>
          <span
            v-if="clipboard"
            class="copy-btn"
            :data-clipboard-text="copyText" 
            @click="copyHandle"
          >
          </span>
        </div>
      </div>
      <div :class="{'xtd-noactivity-container-footer': !isIPad, 'iPad-xtd-noactivity-container-footer': isIPad}">
        <div class="select-city" v-if="isIPad" @click="jumpSelectCity">{{configInfo.cityName ? configInfo.cityName : gettext('选择城市')}}</div>
        <div v-if="isIPad" class="iPad-xtd-noactivity-tips">{{gettext('暂无活动')}}</div>
        <common-income :item="configInfo"/>
      </div>
      <select-city :cityList="configInfo.cityList" 
        :show="isShowCitySelect" 
        :locationCity="configInfo.cityName" 
        @select="handleSelected"
        @clickMask="closeMask"></select-city>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
import CommonIncome from './commonIncome'
import { mapGetters, mapActions } from 'vuex'
import Schema from '@/common/js/schema'
import SelectCity from '@/components/select-city'
import { globalParamsSchema, xtdConfigSchema } from '@/store/d/schema'
import { setTitle, getShopInfo, closePage, getUserInfo, getRiderBackBtn } from '@/common/js/bridge'
import { debounce } from '@/common/js/utils'
import getCountryConfig from '@/common/config/country-config'

export default {
  name: 'noActivity',
  components: {
    CommonIncome,
    SelectCity
  },
  data () {
    return {
      clipboard: null,
      configInfo: {},
      isShowCitySelect: false
    }
  },
  computed: {
    ...mapGetters(['globalParams', 'xtdConfig']),
    imgStyle () {

    },
    copyText () {
      return this.configInfo && this.configInfo.activeCode
    },
    meanfulGlobalParams () {
      return Schema.compare(this.globalParams, globalParamsSchema)
    },
    meanfulXtdConfigInfo () {
      return Schema.compare(this.xtdConfig, xtdConfigSchema)
    },
    country () {
      if (this.$store.state.country === 'MX' || this.$store.state.country === 'JP' || this.$store.state.country === 'BR') {
        return this.$store.state.country
      } else {
        return 'MX'
      }
    },
    formatHeadImg () {
      // 暂时使用产品提供的占位图代替后端传来的图
      if (this.isIPad) {
        return getCountryConfig.bannerBgConfig.COUPON_BG(this.country)['DGD_BANNER_BG_PAD']
      } else {
        return getCountryConfig.bannerBgConfig.COUPON_BG(this.country)['DGD_BANNER_BG']
      }
    }
  },
  methods: {
    ...mapActions(['getGlobalInfo', 'getXtdConfigInfo']),
    close () {
      closePage()
    },
    initClipBoard () {
      // TODO: 不支持clipboard兼容
      if (Clipboard.isSupported()) {
        this.clipboard = new Clipboard('.copy-btn')
      }
    },
    copyHandle: debounce(function () {
      this.clipboard.on('success', e => {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext('复制成功'),
          type: 'correct'
        })
        toast.show()
        e.clearSelection()
      })
      this.clipboard.on('error', e => {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext('当前手机系统不支持自动复制'),
          type: 'error'
        })
        toast.show()
        e.clearSelection()
      })
    }, 200),
    jumpSelectCity () {
      this.isShowCitySelect = true
    },
    async fetchAcquisitionConfig (data) {
      let res = await this.getXtdConfigInfo(data)
      if (res && res.errno === 0 && res.data) {
        this.configInfo = res.data
      } else {
        throw res && res.errmsg
      }
    },
    lazyImgObj (value) {
      return {
        src: value
      }
    },
    getSourceInfo () {
      if (this.isInDApp) {
        return Promise.all([this.getGlobalInfo(), getUserInfo()])
          .then((data) => {
            return {
              ...data[0],
              ...data[1],
              sourceType: 'd',
              sourceID: data[1].uid
            }
          })
          .catch((err) => {
            console.log('err', err)
          })
      } else if (this.isInBApp || this.isIPad) {
        return Promise.all([this.getGlobalInfo(), getShopInfo()])
          .then((data) => {
            return {
              ...data[0],
              ...data[1],
              sourceType: 'b',
              sourceID: data[1].shopId
            }
          })
      }
      return Promise.resolve({})
    },
    handleSelected (city) {
      this.getSourceInfo()
        .then((data) => {
          return this.fetchAcquisitionConfig({
            ...data,
            cityId: city.cityId,
            required: true
          })
        })
      this.closeMask()
    },
    closeMask () {
      this.isShowCitySelect = false
    }
  },
  created () {
    if (this.isInDApp) getRiderBackBtn()
    setTitle(this.gettext('推荐骑手'))
    this.initClipBoard()
    this.getSourceInfo()
      .then((data) => this.fetchAcquisitionConfig(data))
      .catch(err => {
        const toast = this.$createToast({
          time: 3000,
          txt: err,
          type: 'error'
        })
        toast.show()
      })
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/variables";
$conversion = 0.5859375px
.xtd-noactivity-container {
  background-color: white;
  width: 100%
  height: 100%
  overflow-x: hidden
  overflow-y: auto;
  text-align: center;
  &-main {
    margin: 0  0 74px 0 
    .banner {
      .img-wrapper {
        background-repeat: no-repeat
        background-position: center
        background-size contain
        width: 100%
      }
    }
  }
  .select-city {
    position: relative;
    margin: 40px auto;
    padding: 0 60px 0 20px;
    box-sizing: border-box;
    height: 58px;
    line-height: 58px;
    border-color(2px);
    border-radius: 100px;
    display: inline-block;
    text-align: center;
    font-family: Aspira Medium;
    font-size: 28px;
    font-color();
    &::after {
      position: absolute;
      display: block;
      content: "";
      width: 11px;
      height: 20px;
      arrow-right();
      right: 30px;
      top: 50%;
      margin-top: -10px;
    }
  }
  .line-wrap {
    display: flex;
    justify-content: center;
    .line {
      display: block;
      width: 146px;
      height: 2px;
      margin-top: 14px;
      &.r  {
        background: linear-gradient(to right, #D8D8D8 , #ffffff);
        margin-left: 24px;
      }
      &.l {
        background: linear-gradient(to right, #ffffff, #D8D8D8);
        margin-right: 24px;
      }
    }
    .text {
      color: #999999
      display: block
      font-size: 28px
      margin-bottom: 45px;
    }
  }
  .code-box {
    margin-top: 60px
    text-align: center
    .copy-wrap {
      // display: flex;
      // justify-content: center;
      font-size: 0;
      .copy-btn {
        display: inline-block;
        width: 40px;
        height: 40px;
        copy-icon();
        margin-left: 17px
        box-sizing: border-box
      }
      .code {
        font-size: 48px;
        color: #000000;
        letter-spacing: 0;
        text-align: center;
        line-height: 33px;
        font-weight: bold;
        -webkit-user-select: text;
      }
    }
  }
  &-title {
    text-align: center;
    font-size: 40px;
    line-height: 40px;
    margin: 0 100px 50px 100px;
    color: #666;
  }
  &-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    height: 244px;
    width: 100%;
    background: #F7F8FA;
    padding: 39px 0;
    overflow: hidden;
    .xtd-common-income-container {
      padding: 0;
    }
  }

}
.iPad-xtd-noactivity-container {
  background: white;
  overflow-x: hidden
  overflow-y: auto
  text-align: center;
  padding: 28*$conversion  60*$conversion  60*$conversion 60*$conversion;
  display: flex
  &-main {
    margin-right: 60*$conversion
    .iPad-banner {
      height:599*$conversion
      .iPad-img-wrapper {
        width: 590*$conversion
        height: 599*$conversion
        background-repeat: no-repeat
        background-position: center
        background-size: cover
      }
    }
  }
  .select-city {
    position: relative;
    margin: 200*$conversion auto 20*$conversion;
    padding: 0 34*$conversion 0 16*$conversion;
    min-width: 100*$conversion;
    text-align: left;
    box-sizing: border-box;
    height: 42*$conversion;
    line-height: 42*$conversion;
    border-color(1*$conversion);
    display: inline-block;
    border-radius: 100*$conversion;
    font-family: Aspira Medium;
    font-size: 18*$conversion;
    font-color();
    &::after {
      position: absolute;
      display: block;
      content: "";
      width: 6*$conversion;
      height: 10*$conversion;
      arrow-right();
      right: 20*$conversion;
      top: 50%;
      margin-top: -5*$conversion;
    }
  }
  &-footer {
    flex:1
    position: relative
    .iPad-xtd-noactivity-tips {
      font-size: 24*$conversion
      color: #999999;
      text-align: center
      // margin-top: 197*$conversion
    }
    .iPad-xtd-common-income-container {
      position: absolute
      bottom: 0
    }
  }
}
</style>
